import http from "../utils/http";
import { toast } from "../utils/toast";
// 일반 기안 작성 (요청)
export const postDrafts = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/drafts", params)
      .then((res) => {
        toast.success("일반기안 요청이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDraftTemplates = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/editor/template/list", params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};